import styled, { css } from "styled-components";
import backgroundVertical from "../assets/paymentLogos/others/background-vertical.png";
import background from "../assets/paymentLogos/others/background.png";
import failure from "../assets/paymentLogos/others/failure.png";
import success from "../assets/paymentLogos/others/success.png";
export const GRID_WRAPPER = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: 260px;
	grid-row-gap: 10px;
	grid-column-gap: 10px;
	padding-bottom: 40px;
	@media (min-width: 388px) {
		grid-row-gap: 20px;
		grid-column-gap: 20px;
		grid-template-rows: 290px;
	}
	@media (min-width: 572px) {
		grid-template-columns: 1fr 1fr 1fr;
		grid-template-rows: 341px;
	}
	@media (min-width: 756px) {
		grid-template-columns: 1fr 1fr 1fr 1fr;
	}
	@media (min-width: 768px) {
		grid-template-columns: 1fr 1fr 1fr;
		grid-template-rows: 380px;
	}
	@media (min-width: 1000px) {
		grid-template-columns: 1fr 1fr 1fr 1fr;
	}
	@media (min-width: 1024px) {
		grid-template-columns: 1fr 1fr 1fr;
	}
	@media (min-width: 1200px) {
		grid-template-columns: 1fr 1fr 1fr 1fr;
	}
	@media (min-width: 1440px) {
		grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
	}
	${(props) =>
		props.isSub &&
		css`
			grid-template-columns: 1fr !important;
			grid-template-rows: 1fr !important;
		`}
`;

export const WithdrawItem = styled.div`
		height: 260px;
		overflow: hidden;
		background: linear-gradient(180deg, #f7f7fc, #e7e9f3);
		margin-bottom: 20px;
		border-radius: 20px;
		&:hover {
			background: linear-gradient(180deg, #f9a641, #f76b1c);
			.logo-wrapper img {
				//filter: brightness(0) invert(1);

				filter: invert(0.9) grayscale(100%) brightness(201%);
			}
		}
		@media (min-width: 388px) {
			height: 290px;
		}
		@media (min-width: 768px) {
			height: 341px;
		}

		.logo-wrapper {
			position: relative;
			height: 80px;
			line-height: 80px;
			padding-inline-start: 10px;
			padding-inline-end: 10px;
			@media (min-width: 768px) {
				height: 95px;
				line-height: 95px;
			}
			img {
				width: -webkit-fill-available;
			}
		}
	`,
	WithdrawLogoWrapper = styled.div`
		height: 80px;
		line-height: 80px;
		padding-inline-start: 10px;
		padding-inline-end: 10px;
		@media (min-width: 768px) {
			height: 95px;
			line-height: 95px;
		}
	`,
	WithdrawMinMax = styled.div`
		background-color: #ffffff;
		padding: 14px 0px 12px 15px;
		height: 70px;
		font-size: 21px;
		font-weight: 300;
		color: #1f1616;
		line-height: 26px;
		display: flex;
		flex-direction: column;
		@media (min-width: 388px) {
			height: 80px;
			font-size: 24px;
			line-height: 28px;
		}
		@media (min-width: 428px) {
			font-size: 24px;
			line-height: 29px;
		}
		@media (min-width: 464px) {
			font-size: 29px;
		}
		@media (min-width: 572px) {
			font-size: 22px;
		}
		@media (min-width: 665px) {
			font-size: 29px;
		}
		@media (min-width: 756px) {
			font-size: 22px;
		}
		@media (min-width: 768px) {
			height: 106px;
			font-size: 36px;
			line-height: 38px;
		}
		@media (min-width: 790px) {
			font-size: 38px;
		}
		@media (min-width: 1000px) {
			font-size: 36px;
		}
		@media (min-width: 1050px) {
			font-size: 38px;
		}
		@media (min-width: 1200px) {
			font-size: 32px;
		}
		@media (min-width: 1328px) {
			font-size: 38px;
		}
		@media (min-width: 1440px) {
			font-size: 32px;
		}
		${(props) =>
			props.isHover &&
			css`
				background-color: #d85b00;
				color: #f7f7fc;
			`}
	`,
	WithdrawName = styled.div`
		font-size: 14px;
		padding-top: 5px;
		line-height: 14px;
		padding-right: 10px;
		height: 70px;
		color: var(--dark);

		@media (min-width: 388px) {
			font-size: 11px;
			height: 80px;
		}
		@media (min-width: 768px) {
			font-size: 14px;
			height: 100px;
		}
		padding-left: 15px;
		${(props) =>
			props.isHover &&
			css`
				color: #ffffff;
			`}
	`,
	WithdrawNameFeaturesWrapper = styled.div`
		height: 70px;
		color: var(--dark);
		overflow-y: hidden;
		overflow: hidden;
		@media (min-width: 388px) {
			font-size: 11px;
			height: 80px;
		}
		@media (min-width: 768px) {
			font-size: 14px;
			height: 100px;
		}
		${(props) =>
			props.isHover &&
			css`
				color: #ffffff;
				overflow-y: auto;
			`}
	`,
	WithdrawButton = styled.div`
		height: 40px;
		background: linear-gradient(180deg, #f9a641, #f76b1c);
		font-size: 12px;
		font-weight: 600;
		text-align: center;
		color: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		border-radius: 20px;
		@media (min-width: 388px) {
			height: 50px;
			font-size: 12px;
		}
		@media (min-width: 768px) {
			height: 40px;
			font-size: 12px;
		}
		${(props) =>
			props.isHover &&
			css`
				background: #f7f7fc;
				color: var(--main-color);
			`}
	`,
	Warning = styled.div`
		font-size: 10px;
		padding-top: 5px;
	`;
export const DepositItem = styled.div`
		height: 260px;
		overflow: hidden;
		background-color: #d4d6da;
		padding-top: 30px;
		padding-bottom: 10px;
		margin-bottom: 20px;
		&:hover {
			background-color: var(--main-color);
		}
	`,
	DepositLogoWrapper = styled.div`
		padding-bottom: 29px;
		padding-inline-start: 18px;
		& img {
			height: 21px;
		}
	`,
	DepositMinMax = styled.div`
		background-color: #e9ebef;
		padding: 14px 0px 12px 15px;
		height: 70px;
		font-size: 27px;
		font-weight: 300;
		color: #545454;
		line-height: 22px;
		display: flex;
		flex-direction: column;
	`,
	DepositName = styled.div`
		line-height: 14px;
		font-size: 11px;
		color: #000000;
		padding-inline-start: 15px;
		padding-top: 9px;
	`,
	DepositFeature = styled.div`
		line-height: 14px;
		font-size: 11px;
		color: #000000;
		padding-inline-start: 15px;
		font-weight: 700;
	`,
	DepositButton = styled.div`
		line-height: 40px;
		background-color: #000000;
		font-size: 11px;
		font-weight: 600;
		text-align: center;
		margin-top: 9px;
		color: #ffffff;
	`,
	PaymentWrapper = styled.div`
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-template-rows: 50px 1fr 60px;
		grid-template-areas: "image image" "page page" "nav nav";
		height: 100%;
		min-height: calc(100vh - 230px);
		background-color: #d4d6da;
		border-radius: 20px;
		overflow: hidden;
		@media (min-width: 428px) {
			grid-template-rows: 60px 1fr 60px;
		}
		@media (min-width: 1024px) {
			grid-template-rows: 1fr 60px;
			grid-template-columns: 120px 1fr 1fr;
			grid-template-areas: "image page page" "image nav nav";
		}
		@media (min-width: 1420px) {
			min-height: calc(100vh - 300px);
		}
	`,
	PaymentImg = styled.div`
		background: url(${backgroundVertical}) no-repeat;
		background-size: 428px;
		background-position-x: center;
		background-position-y: bottom;
		grid-area: image;
		@media (min-width: 428px) {
			background-size: 768px;
		}
		@media (min-width: 768px) {
			background-size: cover;
		}
		@media (min-width: 1024px) {
			position: relative;
			&::before {
				content: " ";
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: url(${background}) no-repeat;
				background-size: 150px;
				z-index: 1;
			}
			&::after {
				content: " ";
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: linear-gradient(to right, #e89200, #eea300);
				z-index: 0;
			}
		}
	`,
	Page = styled.div`
		display: grid;
		grid-template-rows: 60px 1fr;
		grid-area: page;
		@media (min-width: 428px) {
			grid-template-rows: 70px 1fr;
		}
		@media (min-width: 768px) {
			grid-template-rows: 65px 1fr;
		}
	`,
	Title = styled.div`
		background-color: #ffffff;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-inline-end: 11px;
		padding-inline-start: 14px;
	`,
	Logo = styled.img`
		height: -webkit-fill-available;
	`,
	FeatureTitleBox = styled.div`
		text-align: end;
	`,
	Feature = styled.div`
		font-size: 9.2px;
		line-height: 1.27;
		color: #000000;
		font-weight: ${(props) => (props.bold ? 700 : 400)};
	`,
	Content = styled.div`
		background-color: #ffffff;
	`,
	ContentTitle = styled.div`
		line-height: 32px;
		font-size: 10px;
		height: 32px;
		display: flex;
		justify-content: center;
		color: #000000;
		background-color: #f7f7fc;
	`,
	Navigation = styled.div`
		grid-area: nav;
		display: grid;
		grid-template-columns: 1fr 1fr;
		background-color: #ffffff;
		padding: 10px 5px 10px 5px;
	`,
	Box = styled.div`
		display: grid;
		grid-template-rows: "21px 48px";
	`,
	BoxWrapper = styled.div`
		@media (min-width: 768px) {
			display: grid;
			grid-template-columns: 1fr 1fr;
			grid-template-rows: 1fr;
			grid-column-gap: 10px;
		}
	`,
	BoxTitle = styled.div`
		background-color: #000000;
		text-align: center;
		color: #ffffff;
		font-size: 9px;
		height: 21px;
		line-height: 21px;
	`,
	Stake = styled.div`
		color: #545454;
		background-color: #e9ebef;
		height: 48px;
		line-height: 48px;
		display: flex;
		justify-content: center;
		font-size: 14px;
		font-weight: 600;
		input {
			font-size: 12px;
			width: 100%;
			line-height: 30px;
			padding-inline-start: 8px;
			outline: none;
			border: 0;
			background: none;
		}
	`,
	MaskedInput = styled.div`
		color: #545454;
		background-color: #e9ebef;
		height: 48px;
		input {
			font-size: 14px;
			font-weight: 400;
			width: 100%;
			line-height: 48px;
			padding-inline-start: 8px;
			text-align: center;
			outline: none;
			border: 0;
			background: none;
		}
	`,
	StakeInput = styled.input`
		color: #545454;
		background-color: #e9ebef;
		height: 48px;
		line-height: 48px;
		display: flex;
		text-align: center;
		font-size: 14px;
		font-weight: 600;
		width: 100%;
		border: 0;
		padding: 1px 8px;
		outline: none;
	`,
	ResultBox = styled.div`
		padding: 0 20px;
		height: 32px;
		background-color: #d9dbe9;
		color: #14142a;
		font-weight: 400;
		line-height: 32px;
		display: flex;
		justify-content: space-between;
	`,
	NavigationItem = styled.div`
		background: ${(props) =>
			props.back ? "#ffffff" : "linear-gradient(180deg, #7D36D4 0%, #380383 100%)"};
		color: ${(props) => (props.back ? "#6315C3" : "#ffffff")};
		opacity: ${(props) =>
			(props.filled && props.filled === true) || props.back || props.close ? "1" : "0.5"};
		display: flex;
		justify-content: center;
		align-items: center;
		font-weight: 600;
		font-size: 12px;
		text-align: center;
		cursor: pointer;
		border-radius: 20px;
		border: 1px solid #6315c3;
		margin-right: 5px;
		margin-left: 5px;
	`,
	ExternalWrapper = styled.div`
		padding-top: 13px;
		display: grid;
		grid-template-rows: 28px 1fr 60px;
		height: 100%;
		grid-row-gap: 9px;
	`,
	ExternalButton = styled.a`
		height: 50px;
		border-radius: 25px;
		background-color: var(--main-color);
		font-size: 14px;
		font-weight: 700;
		letter-spacing: normal;
		line-height: 17px;
		text-align: center;
		color: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-left: 10px;
		padding-right: 10px;
	`,
	Caution = styled.div`
		font-size: 9px;
		font-style: italic;
		line-height: 1.33;
		color: #3d4045;
		padding-left: 10px;
	`,
	ExternalDescription = styled.div`
		font-size: 10px;
		font-weight: 700;
		color: #3d4045;
		line-height: normal;
		height: 28px;
		padding-left: 10px;
	`,
	ResultContent = styled.div`
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	`,
	SuccessImg = styled.div`
		background-image: url(${success});
		background-size: contain;
		background-repeat: no-repeat;
		width: 52px;
		height: 53px;
	`,
	FailureImg = styled.div`
		background-image: url(${failure});
		background-size: contain;
		background-repeat: no-repeat;
		width: 52px;
		height: 53px;
	`,
	ResultText = styled.div`
		height: 112px;
		font-size: 30px;
		font-weight: 700;
		line-height: 1.07;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #000000;
		text-align: center;
	`,
	MissingDocumentWrapper = styled.div`
		display: flex;
		height: 347px;
		padding: 30px 20px;
		flex-direction: column;
		align-items: center;
		gap: 10px;
		align-self: stretch;

		span {
			color: #fff;
			text-align: center;
			align-self: stretch;

			&:first-of-type {
				font-size: 24px;
				font-weight: 600;
				line-height: 32px;
				letter-spacing: 0.75px;
			}

			&:last-of-type {
				font-size: 12px;
				font-weight: 400;
				line-height: 20px;
				letter-spacing: 0.3px;
			}
		}
	`;
